// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M21,2H3v4h1v16h16V6h1V2z M19,21H5V6h14V21z M20,5H4V3h16V5z" />
	<rect x="8" y="8" width="8" height="1" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-box-Bvr_uX3S.js.map
